import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down-bar', 'IconArrowDownBar', [
  ['path', { d: 'M12 3v18', key: 'svg-0' }],
  ['path', { d: 'M9 18l3 3l3 -3', key: 'svg-1' }],
  ['path', { d: 'M9 3h6', key: 'svg-2' }],
]);
